export const BAD_QUOTE_REVISION = 114;



// WEBPACK FOOTER //
// ../widget-build-and-quote/src/constants/errorCodes.js